export default "__VITE_ASSET__1ihcEhm5__"